import React, { useState } from 'react';
import { LogoSlug, LOGO_NAMES, logoSrc } from '../../data/logos';

interface ToolLogoProps {
  slug: LogoSlug;
  /** Render the tool name next to the mark. */
  showLabel?: boolean;
  /** Icon edge size in px. */
  size?: number;
  className?: string;
}

/**
 * A single tool logo in a node-styled tile. If the SVG is missing the tile
 * degrades to the tool's initial rather than showing a broken image.
 */
const ToolLogo: React.FC<ToolLogoProps> = ({
  slug,
  showLabel = true,
  size = 20,
  className = '',
}) => {
  const [errored, setErrored] = useState(false);
  const name = LOGO_NAMES[slug];

  return (
    <div className={`logo-tile ${className}`} title={name}>
      {errored ? (
        <span
          className="grid shrink-0 place-items-center rounded-md bg-canvas-deep font-display text-[11px] font-bold text-neon-cyan"
          style={{ width: size, height: size }}
          aria-hidden="true"
        >
          {name.charAt(0)}
        </span>
      ) : (
        <img
          src={logoSrc(slug)}
          alt={showLabel ? '' : name}
          aria-hidden={showLabel || undefined}
          loading="lazy"
          width={size}
          height={size}
          style={{ width: size, height: size }}
          onError={() => setErrored(true)}
        />
      )}
      {showLabel && <span>{name}</span>}
    </div>
  );
};

export default ToolLogo;
